var map = {
	"./alcohol.svg": "b91c",
	"./breakfast.svg": "f14d",
	"./burger.svg": "b457",
	"./chicken.svg": "3c4f",
	"./coffee.svg": "bd1b",
	"./convenience.svg": "1e42",
	"./desserts.svg": "d02b",
	"./fastfood.svg": "4acc",
	"./healthy.svg": "9d8b",
	"./sandwitch.svg": "d418",
	"./vegan.svg": "ec2a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c8c1";